<input #_fileInput type="file" (change)="openCropperDialog($event)" accept="image/*" hidden>

<div>
  <button mat-stroked-button class="stroked-cropper-button" (click)="_fileInput.click()">
    Select File
  </button>
</div>
